import { render, staticRenderFns } from "./DialogMemoriaCalculo.vue?vue&type=template&id=38924208&scoped=true"
import script from "./DialogMemoriaCalculo.vue?vue&type=script&lang=js"
export * from "./DialogMemoriaCalculo.vue?vue&type=script&lang=js"
import style0 from "./DialogMemoriaCalculo.vue?vue&type=style&index=0&id=38924208&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38924208",
  null
  
)

export default component.exports